﻿const en = {
  title: 'Anti-fraud model',
  subtitle: 'Configure your anti-fraud models',
  downloadDocuments: 'Add documents',
  metadata: 'Metadata',
  table: {
    name: 'Document name',
    risk: 'Risk level',
    score: 'Score',
    status: 'Status',
  },
  dropdown: {
    details: 'Details',
    download: 'Download the document',
    downloadReport: 'Download the report',
    delete: 'Delete',
  },
  levelStates: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    unknown: 'Unknown',
  },
  riskOverviewTitle: 'Fraud risk analysis for the document {{name}}',
  sensitivitySettings: {
    modalTitle: 'Configure the model sensitivity',
    modalOpenButton: 'Configure the model sensitivity',
    submitSettingsButton: 'Update',
    cancelSettingsButton: 'Cancel',
    seuilChangementAlignement: 'Line break',
    seuilDifferenceEspace: 'Spacing between words',
    seuilDifferenceCouleur: 'Background colorimetry',
    metadataKeywords: 'Presence of suspicious metadata',
    metadataKeywordsBlacklist: 'List of suspicious metadata',
    numberOfDays: 'Number of days since the last edit',
    minimumLayer: 'Minimum number of layers',
    size: 'Font size difference',
    font: 'Font',
  },
  assessmentList: {
    emptyListText: 'No supporting data',
    elementHeader: 'Element',
    valueHeader: 'Value',
  },
  imageNotFound: 'Image not found',
  assessmentTypes: {
    Size: 'Font sizes',
    Spacing: 'Spacing',
    Colorimetry: 'Colorimetry',
    MetadataKeywords: 'Metadata check',
    Font: 'Font check',
    Parallelism: 'Parallelism',
  },
};

export default en;
export type Translations = typeof en;
